import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { FormDependencyTypes } from '@shared/common/form/form.dependency-types';
import { FormValidationService } from '@shared/common/form/domain/service/form-validation.service';
import { FreeTextLocaleSynchronizationService } from '@shared/common/form/domain/service/free-text-locale-synchronization.service';
import { FormFieldViewRegistryService } from '@shared/common/form/application/service/form-field-view-registry.service';
import { ToFormDataApiDataTransformer } from '@shared/common/form/data/transformer/to-form-data.api-data-transformer';
import BooleanComponent from '@shared/common/form/application/component/boolean/BooleanComponent.vue';
import type { FormFieldBooleanComponent } from '@shared/common/form/application/component/boolean/form-field-boolean-component.types';
import type { FormFieldTextComponent } from '@shared/common/form/application/component/text/form-field-text-component.types';
import type { FormFieldNumberComponent } from '@shared/common/form/application/component/number/form-field-number-component.types';
import type { FormFieldMoneyComponent } from '@shared/common/form/application/component/money/form-field-money-component.types';
import type { FormFieldSelectComponent } from '@shared/common/form/application/component/select/form-field-select-component.types';
import type { FormFieldFileComponent } from '@shared/common/form/application/component/file/form-field-file-component.types';
import type { FormFieldDateComponent } from '@shared/common/form/application/component/date/form-field-date-component.types';
import type { FormFieldComponents } from '@shared/common/form/application/type/form-field-components.type';
import { formFieldViewKeyComponent } from '@shared/common/form/application/constant/form-field-view-key-components.constant';
import {
  InputCurrency,
  InputDate,
  InputFile,
  InputNumber,
  InputSelect,
  InputText,
} from '@kiplin/web-common/design-system';
import InputTranslatedComponent from '@shared/common/form/application/component/translated/InputTranslatedComponent.vue';
import type { FormFieldTranslatedPropertyComponent } from '@shared/common/form/application/component/translated/form-field-translated-property-component.types';

export const formContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options
    .bind<FormValidationService>(FormDependencyTypes.FormValidationService)
    .to(FormValidationService)
    .inSingletonScope();
  options
    .bind<FreeTextLocaleSynchronizationService>(FormDependencyTypes.FreeTextLocaleSynchronizationService)
    .to(FreeTextLocaleSynchronizationService)
    .inSingletonScope();
  options
    .bind<FormFieldViewRegistryService>(FormDependencyTypes.FormFieldViewRegistryService)
    .to(FormFieldViewRegistryService);
  options
    .bind<ToFormDataApiDataTransformer<Record<string, unknown>>>(FormDependencyTypes.ToFormDataApiDataTransformer)
    .to(ToFormDataApiDataTransformer)
    .inSingletonScope();
  options
    .bind<FormFieldBooleanComponent>(FormDependencyTypes.FormFieldBooleanComponent)
    .toConstantValue(BooleanComponent);
  options.bind<FormFieldTextComponent>(FormDependencyTypes.FormFieldTextComponent).toConstantValue(InputText);
  options.bind<FormFieldNumberComponent>(FormDependencyTypes.FormFieldNumberComponent).toConstantValue(InputNumber);
  options.bind<FormFieldMoneyComponent>(FormDependencyTypes.FormFieldMoneyComponent).toConstantValue(InputCurrency);
  options.bind<FormFieldSelectComponent>(FormDependencyTypes.FormFieldSelectComponent).toConstantValue(InputSelect);
  options.bind<FormFieldFileComponent>(FormDependencyTypes.FormFieldFileComponent).toConstantValue(InputFile);
  options.bind<FormFieldDateComponent>(FormDependencyTypes.FormFieldDateComponent).toConstantValue(InputDate);
  options
    .bind<FormFieldTranslatedPropertyComponent>(FormDependencyTypes.FormFieldTranslatedPropertyComponent)
    .toConstantValue(InputTranslatedComponent);
  options
    .bind<FormFieldComponents>(FormDependencyTypes.FormFieldViewKeyComponents)
    .toConstantValue(formFieldViewKeyComponent);
});
